// Treaments.js - Estatica Skin and Laser

import React, { useState } from "react";
import MyNavbar from "../../../components/customer/myNavbar/MyNavbar";
import Footer from "../../../components/customer/footer/Footer";
import HeroSection from "./HeroSection";
import AllTreatments from "./AllTreatments";

const Treaments = () => {
  const [activeFilter, setActiveFilter] = useState("All");
  

  return (
    <>
      <MyNavbar />
      {/* <HeroSection
        activeFilter={activeFilter}
        setActiveFilter={setActiveFilter}
      /> */}
      <AllTreatments screen={"treatment"} activeFilter={activeFilter} />
      <Footer />
    </>
  );
};

export default Treaments;